import { h } from "@stencil/core";
import { dataTypeInGeneXus } from "../combo-box/models";
import { renderShowcaseProperties } from "../utils";
import { chatCallbacks, chatTranslations, codeFixerRecord, longChatRecord } from "./callbacks";
// import { mercuryChatMessageRender } from "./mercury-code-render";
const state = {};
const unanimoSendContainerLayout = {
    sendContainerBefore: ["stop-response-button"],
    sendContainerAfter: ["send-button"]
};
const mercurySendContainerLayout = {
    sendInputAfter: ["send-button"]
};
const render = designSystem => {
    state.sendContainerLayout =
        designSystem === "unanimo"
            ? unanimoSendContainerLayout
            : mercurySendContainerLayout;
    return (h("ch-chat", { autoScroll: state.autoScroll, callbacks: chatCallbacks, class: "chat", loadingState: state.loadingState, markdownTheme: designSystem === "unanimo"
            ? "unanimo/markdown-viewer"
            : "mercury/markdown-viewer", newUserMessageAlignment: state.newUserMessageAlignment, newUserMessageScrollBehavior: state.newUserMessageScrollBehavior,
        // renderItem={
        //   designSystem === "unanimo"
        //     ? undefined
        //     : mercuryChatMessageRender("mercury/markdown-viewer")
        // }
        items: state.items, liveMode: state.liveMode, liveModeConfiguration: state.liveModeConfiguration, sendButtonDisabled: state.sendButtonDisabled, sendContainerLayout: state.sendContainerLayout, sendInputDisabled: state.sendInputDisabled, showAdditionalContent: state.showAdditionalContent, translations: chatTranslations, waitingResponse: state.waitingResponse }, h("div", { slot: "additional-content" }, "Custom content that is rendered when the chat renders content"), state.sendContainerLayout.sendInputBefore && (h("button", { slot: "send-input-before", class: "button-primary" }, "Action")), state.sendContainerLayout.sendInputAfter && (h("ch-combo-box-render", { slot: "send-input-after", accessibleName: "Data Types", class: "combo-box", model: dataTypeInGeneXus }))));
};
const showcaseRenderProperties = [
    {
        caption: "Items",
        properties: [
            {
                id: "items",
                accessibleName: "Items",
                values: [
                    {
                        caption: "GeneXus Enterprise AI Playground",
                        value: longChatRecord
                    },
                    { caption: "Code Fixer", value: codeFixerRecord }
                ],
                value: codeFixerRecord,
                type: "enum"
            }
        ]
    },
    {
        caption: "Properties",
        properties: [
            {
                id: "loadingState",
                caption: "Loading State",
                values: [
                    { caption: "initial", value: "initial" },
                    { caption: "loading", value: "loading" },
                    {
                        caption: "more-data-to-fetch",
                        value: "more-data-to-fetch"
                    },
                    { caption: "all-records-loaded", value: "all-records-loaded" }
                ],
                value: "all-records-loaded",
                type: "enum"
            },
            {
                id: "newUserMessageAlignment",
                caption: "New User Message Alignment",
                values: [
                    { caption: "Start", value: "start" },
                    { caption: "End", value: "end" }
                ],
                value: "start",
                render: "radio-group",
                type: "enum"
            },
            {
                id: "newUserMessageScrollBehavior",
                caption: "New User Message Scroll Behavior",
                values: [
                    { caption: "Instant", value: "instant" },
                    { caption: "Smooth", value: "smooth" }
                ],
                value: "instant",
                render: "radio-group",
                type: "enum"
            },
            {
                id: "autoScroll",
                caption: "Auto Scroll",
                values: [
                    { caption: "Never", value: "never" },
                    { caption: "At scroll end", value: "at-scroll-end" }
                ],
                value: "at-scroll-end",
                render: "radio-group",
                type: "enum"
            },
            {
                id: "sendButtonDisabled",
                caption: "Send Button Disabled",
                value: false,
                type: "boolean"
            },
            {
                id: "sendInputDisabled",
                caption: "Send Input Disabled",
                value: false,
                type: "boolean"
            },
            {
                id: "showAdditionalContent",
                caption: "Show Additional Content",
                value: false,
                type: "boolean"
            },
            {
                id: "waitingResponse",
                caption: "Waiting Response",
                value: false,
                type: "boolean"
            }
        ]
    },
    {
        caption: "Live Mode",
        properties: [
            {
                id: "liveMode",
                caption: "Enabled",
                value: false,
                type: "boolean"
            },
            {
                id: "liveModeConfiguration",
                caption: "Configuration",
                type: "object",
                render: "independent-properties",
                properties: [
                    {
                        id: "url",
                        caption: "URL",
                        value: undefined,
                        type: "string"
                    },
                    {
                        id: "token",
                        caption: "Token",
                        value: undefined,
                        type: "string"
                    }
                ]
            }
        ]
    }
];
const showcasePropertiesInfo = [
    { name: "class", fixed: true, value: "chat", type: "string" },
    {
        name: "autoScroll",
        defaultValue: "at-scroll-end",
        type: "string"
    },
    {
        name: "items",
        fixed: true,
        value: "controlUIModel",
        type: "function"
    },
    {
        name: "liveMode",
        defaultValue: false,
        type: "boolean"
    },
    {
        name: "loadingState",
        defaultValue: "initial",
        type: "string"
    },
    {
        name: "newUserMessageAlignment",
        defaultValue: "end",
        type: "string"
    },
    {
        name: "newUserMessageScrollBehavior",
        defaultValue: "instant",
        type: "string"
    },
    {
        name: "sendButtonDisabled",
        defaultValue: false,
        type: "boolean"
    },
    {
        name: "sendInputDisabled",
        defaultValue: false,
        type: "boolean"
    },
    {
        name: "showAdditionalContent",
        defaultValue: false,
        type: "boolean"
    },
    {
        name: "waitingResponse",
        defaultValue: false,
        type: "boolean"
    }
];
export const chatShowcaseStory = {
    properties: showcaseRenderProperties,
    markupWithUIModel: {
        uiModelType: "ChatMessage[]",
        uiModel: () => state.items,
        render: {
            react: () => `<ChChat${renderShowcaseProperties(state, "react", showcasePropertiesInfo)}
      >${state.showAdditionalContent
                ? '\n        <div slot="additional-content">Your content here...</div>\n      '
                : ""}${state.sendContainerLayout.sendInputBefore
                ? '\n        <div slot="send-input-before">Your content here...</div>\n      '
                : ""}${state.sendContainerLayout.sendInputAfter
                ? '\n        <div slot="send-input-after">Your content here...</div>\n      '
                : ""}</ChChat>`,
            stencil: () => `<ch-chat${renderShowcaseProperties(state, "stencil", showcasePropertiesInfo)}
        >${state.showAdditionalContent
                ? '\n          <div slot="additional-content">Your content here...</div>\n        '
                : ""}${state.sendContainerLayout.sendInputBefore
                ? '\n          <div slot="send-input-before">Your content here...</div>\n        '
                : ""}${state.sendContainerLayout.sendInputAfter
                ? '\n          <div slot="send-input-after">Your content here...</div>\n        '
                : ""}</ch-chat>`
        }
    },
    render: render,
    state: state
};
